module.exports = __webpack_public_path__ + "img/banner-b.50d9ccef.png";